// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LanguageSelectorList-module-listWrapper-1xLYS{text-align:start;width:100%;z-index:1}[dir=rtl] .LanguageSelectorList-module-listWrapper-1xLYS{text-align:end}", ""]);
// Exports
exports.locals = {
	"listWrapper": "LanguageSelectorList-module-listWrapper-1xLYS"
};
module.exports = exports;
